<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal text-dark" id="d-ssn-modal" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2>{{ user.name }}</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="d-input-group">
          <label class="d-label">CPR-nummer</label>
          <input
            type="text"
            class="d-input"
            v-model="ssn"
            ref="ssn_input"
            placeholder="ddmmåå-nnnn"
            inputmode="numeric"
            maxlength="11"
            @keydown.enter="onSubmit"
            :class="{'is-invalid': !!error}"
          />
          <p v-if="error" class="text-explainer marg-05-top">{{ error }}</p>
        </div>

        <p class="ssn-explainer">
          Docendo henter ansættelser fra lønsystemet ved at matche på CPR-numre. Det sker automatisk hver nat.
        </p>
      </div>

      <div class="d-modal__buttons">
        <div></div>
        <div>
          <button class="do-bttn" @click="$emit('close')">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button
            class="do-bttn do-bttn--submit"
            :class="{
              'do-bttn--submit--disabled': !isValid || isSubmitting,
              'do-bttn--submit--loading': isSubmitting
            }"
            @click="onSubmit"
          >
            {{ $t('vue2.common.save') }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

export default {
  name: 'SalarySsnModal',
  components: {DModal},
  props: {
    user: {
      default: null
    }
  },
  data () {
    return {
      ssn: '',
      isSubmitting: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    ssnDigits () {
      return String(this.ssn).replace(/\D+/g, '')
    },
    isValid () {
      return this.ssnDigits.length === 10
    },
    error () {
      if (this.ssnDigits.length === 0) return ''
      if (this.ssnDigits.length !== 10) return 'CPR-nummer skal være 10 cifre'
      return ''
    }
  },
  methods: {
    onSubmit () {
      if (!this.isValid || this.isSubmitting) {
        return
      }
      this.isSubmitting = true
      const changes = {ssn: this.ssnDigits}
      docendo.updateUsers(this.schoolId, this.user.id, changes, success => {
        // Genhent brugere, så listen opdateres reaktivt (getteren tracker ikke ssn direkte)
        this.$store.dispatch('getUsers')
        eventbus.toast = {text: 'CPR-nummer gemt', success: true, position: 'bottomLeft'}
        this.isSubmitting = false
        this.$emit('close')
      }, failure => {
        eventbus.toast = {text: 'CPR-nummer er allerede brugt', success: false}
        this.isSubmitting = false
      })
    }
  },
  beforeMount () {
    if (this.user && this.user.ssn) {
      this.ssn = this.user.ssn
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = this.$refs.ssn_input
      if (el) el.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.d-input-group {
  flex: 1;
  padding: 0;
  margin: 0;
}

.d-input-group .d-input {
  height: 34px;
  width: 100%;
  margin-top: 0.25rem;
}

.ssn-explainer {
  font-size: 12px;
  color: #8898aa;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 0.75rem;
  margin: 0;
  line-height: 1.4;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-input.is-invalid {
  border-color: #e53e3e;
  box-shadow: 0 0 0 1px rgba(229, 62, 62, .2);
}
</style>



// WEBPACK FOOTER //
// SalarySsnModal.vue?2c64bbbb